import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";

import { createNewContactUs } from "../Store/Actions/EnquiryActions";

function ContactUs() {
	const [state, setState] = useState({
		parentName: "",
		mobileNumber: "",
		email: "",
		childAge: "",
		message: "",
	});

	const dispatch = useDispatch();

	const stateObject = useSelector((state) => state.enquiry);

	const onChangeHandler = (e) => {
		setState({ ...state, [e.target.name]: e.target.value });
	};

	let errors = [];
	if (typeof stateObject.errors !== "undefined") {
		stateObject.errors.map((item) => (errors[item.param] = item.msg));
	}

	const submitForm = (e) => {
		e.preventDefault();

		const data = { ...state };
		console.log("Submitting Contact Us Form:", data);
		dispatch(createNewContactUs(data));
	};

	return (
		<>
			<Form onSubmit={submitForm} className="space-y-6 mt-4">
				<div>
					<label className="block !text-sm font-medium !text-gray-700 mb-2">
						Parent's Name
					</label>
					<input
						name="parentName"
						onChange={onChangeHandler}
						type="text"
						className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
						placeholder="Enter your name"
					/>
				</div>
				<div>
					<label className="block !text-sm font-medium !text-gray-700 mb-2">
						Email Address
					</label>
					<input
						name="email"
						onChange={onChangeHandler}
						type="email"
						className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
						placeholder="Enter your email"
					/>
				</div>

				<div>
					<label className="block !text-sm font-medium !text-gray-700 mb-2">
						Mobile Number
					</label>
					<input
						name="mobileNumber"
						onChange={onChangeHandler}
						type="text"
						className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
						placeholder="Enter your mobile number"
					/>
				</div>
				<div>
					<label className="block !text-sm font-medium !text-gray-700 mb-2">
						Child's Age
					</label>
					<select
						name="childAge"
						onChange={onChangeHandler}
						className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
					>
						<option value="0">Select age group</option>
						<option value="5-7">5-7 years</option>
						<option value="8-10">8-10 years</option>
						<option value="11-13">11-13 years</option>
						<option value="14+">14+ years</option>
					</select>
				</div>
				<div>
					<label className="block !text-sm font-medium !text-gray-700 mb-2">
						Message
					</label>
					<textarea
						name="message"
						onChange={onChangeHandler}
						rows="4"
						className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
						placeholder="Tell us how we can help you!"
					></textarea>
				</div>
				<button
					type="submit"
					className="!w-full !bg-gradient-to-r !from-pink-500 !to-purple-500 !text-white py-3 !rounded-2xl !font-bold hover:!shadow-lg !transform hover:!scale-105 !transition-all !duration-300"
				>
					Send Message 📨
				</button>
			</Form>
			<div className="text-center mt-4">
				{stateObject.REQUEST_SUCCESS && (
					<div className="bg-gradient-to-r from-green-400 via-green-500 to-green-700 text-white rounded-2xl px-4 py-2 shadow-lg">
						{stateObject.message ||
							"Enquiry submitted successfully!"}
					</div>
				)}
				{stateObject.REQUEST_FAILED && (
					<div className="bg-gradient-to-r from-red-400 via-red-500 to-red-700 text-white rounded-2xl px-4 py-2 shadow-lg">
						{stateObject.message || "Failed to submit enquiry."}
					</div>
				)}
			</div>
		</>
	);
}

export default ContactUs;
